var t1 = new Date()
var currentDay = t1.getDate();
var currentMonth = t1.getMonth();
var currentyear = t1.getFullYear();
var weekDay = t1.getDay();
var currentHour = t1.getHours()


// **** Better way to set special products in one place **** ////
var specialProduct1 = false;
var specialProduct2 = false;
var specialProduct3 = false;
var specialProduct4 = false;
var specialProduct5 = false;
var specialProduct6 = false;
var bread = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  if (itemCollections.toLowerCase().indexOf('THANKSGIVING PRE-ORDER'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 
  
  if (itemCollections.toLowerCase().indexOf('HOLIDAY PRE-ORDER'.toLowerCase()) > -1) {
    specialProduct2 = true;
  } 

  if (itemCollections.toLowerCase().indexOf('EASTER PRE-ORDER'.toLowerCase()) > -1) {
    specialProduct3 = true;
  } 
}

var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  
  if (specialProduct3 === true) {
  	picker.set('disable', [true, 
                            { from: [2020, 8, 10], to: [2026, 3, 3] }
                           ,{ from: [2026, 3, 6], to: [2045, 9, 23] }
                          ]);
    picker.set('max', 90);   
  
  	if (currentDay === 2 && currentMonth === 3 && currentyear === 2026 && currentHour >= 12) {
      picker.set('min', 3);
    } else if(currentDay === 2 && currentMonth === 3 && currentyear === 2026 && currentHour < 12){
      picker.set('min', 2); 
    }
    
    if (currentDay === 3 && currentMonth === 4 && currentyear === 2026 && currentHour >= 12) {
      picker.set('min', 3);
    } else if(currentDay === 3 && currentMonth === 4 && currentyear === 2026 && currentHour < 12){
      picker.set('min', 2); 
    }

    /*if (currentDay === 22 && currentMonth === 11 && currentyear === 2025 && currentHour >= 12) {
      picker.set('min', 3);
    } else if(currentDay === 24 && currentMonth === 11 && currentyear === 2025 && currentHour < 12){
      picker.set('min', 2); 
    }*/
  } else
  
  if (specialProduct1 === true) {
  	picker.set('disable', [true, 
                            { from: [2020, 8, 10], to: [2026, 10, 22] }
                           ,{ from: [2026, 10, 26], to: [2045, 9, 23] }
                          ]);
    picker.set('max', 40);   
  
  	if (currentDay === 21 && currentMonth === 10 && currentyear === 2026 && currentHour >= 12) {
      picker.set('min', 3);
    } else if(currentDay === 21 && currentMonth === 10 && currentyear === 2026 && currentHour < 12){
      picker.set('min', 2); 
    }
    
    if (currentDay === 22 && currentMonth === 10 && currentyear === 2026 && currentHour >= 12) {
      picker.set('min', 3);
    } else if(currentDay === 22 && currentMonth === 10 && currentyear === 2026 && currentHour < 12){
      picker.set('min', 2); 
    }

    if (currentDay === 23 && currentMonth === 10 && currentyear === 2026 && currentHour >= 12) {
      picker.set('min', 3);
    } else if(currentDay === 23 && currentMonth === 10 && currentyear === 2026 && currentHour < 12){
      picker.set('min', 2); 
    }

    // if (currentDay === 21 && currentMonth === 11 && currentyear === 2024 && currentHour >= 12) {
    //   picker.set('min', 3);
    // } else if(currentDay === 21 && currentMonth === 11 && currentyear === 2024 && currentHour < 12){
    //   picker.set('min', 2); 
    // }

    // if (currentDay === 22 && currentMonth === 11 && currentyear === 2024 && currentHour >= 12) {
    //   picker.set('min', 3);
    // } else if(currentDay === 22 && currentMonth === 11 && currentyear === 2024 && currentHour < 12){
    //   picker.set('min', 2); 
    // }

    // if (currentDay === 2 && currentMonth === 3 && currentyear === 2023 && currentHour >= 12) {
    //   picker.set('min', 3);
    // } else if(currentDay === 2 && currentMonth === 3 && currentyear === 2023 && currentHour < 12){
    //   picker.set('min', 2); 
    // }

    // if (currentDay === 3 && currentMonth === 3 && currentyear === 2023 && currentHour >= 12) {
    //   picker.set('min', 3);
    // } else if(currentDay === 3 && currentMonth === 3 && currentyear === 2023 && currentHour < 12){
    //   picker.set('min', 2); 
    // }
    
    // if (currentDay === 4 && currentMonth === 3 && currentyear === 2023 && currentHour >= 12) {
    //   picker.set('min', 3);
    // } else if(currentDay === 4 && currentMonth === 3 && currentyear === 2023 && currentHour < 12){
    //   picker.set('min', 2); 
    // }
  
  
    // if (currentDay === 5 && currentMonth === 3 && currentyear === 2023 && currentHour >= 12) {
    //   picker.set('min', 3);
    // } else if(currentDay === 5 && currentMonth === 3 && currentyear === 2023 && currentHour < 12){
    //   picker.set('min', 2); 
    // }
  
    // if (currentDay === 6 && currentMonth === 3 && currentyear === 2023 && currentHour >= 12) {
    //   picker.set('min', 3);
    // } else if(currentDay === 6 && currentMonth === 3 && currentyear === 2023 && currentHour < 12){
    //   picker.set('min', 2); 
    // }
  
    // if (currentDay === 7 && currentMonth === 3 && currentyear === 2023 && currentHour >= 12) {
    //   picker.set('min', 3);
    // } else if(currentDay === 7 && currentMonth === 3 && currentyear === 2023 && currentHour < 12){
    //   picker.set('min', 2); 
    // }
    
//     if (currentDay === 23 && currentMonth === 11 && currentyear === 2021 && currentHour >= 12) {
//       picker.set('min', 3);
//     } else if(currentDay === 22 && currentMonth === 11 && currentyear === 2021 && currentHour < 12){
//       picker.set('min', 2); 
//     }
    
//     if (currentDay === 29 && currentMonth === 11 && currentyear === 2021 && currentHour >= 12) {
//       picker.set('min', 3);
//     } else if(currentDay === 29 && currentMonth === 11 && currentyear === 2021 && currentHour < 12){
//       picker.set('min', 2); 
//     }

  
  }	else  if (bread === true) {
    picker.set('min', 0);  
    picker.set('max', 0);  
  } else {      
   
    picker.set('disable', blackoutdatesCollection);
  }
  
  
}

var thanksgiving = false;
var nonThanksgiving = false;
for (var i = 0; i < crItems.length; i++) {
  var item = crItems[i];
  if (item.id === Number(pickupProduct)) continue;
  if (item.collections.toLowerCase().indexOf('mandatory for pickup') > -1) {
    thanksgiving = true 
  } else {
    nonThanksgiving = true;
  }
}
console.log(thanksgiving, nonThanksgiving)
if (thanksgiving === true && nonThanksgiving === true) {
	disableCheckoutButton();
    var tt = setInterval(function(){disableCheckoutButton();}, 1000);
    setTimeout(function() { clearInterval(tt); }, 5000);   
    // Create the new node to insert
    const newNode = document.createElement("span")
    
    $('[name=checkout]').before(`
		<div class="js-storepickup-message-2">Some items must be ordered separately </div>
	`)
    document.querySelector('#pickup-container').remove();
}

function activateCheckoutButton(){
    document.querySelector('[name=checkout]').disabled = false;
  }

function disableCheckoutButton(){    
    document.querySelector('[name=checkout]').disabled = true;
}
////////////////////
// Cutoff times: ///
////////////////////


// var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  

//   picker.set('disable', blackoutdatesCollection);
// }

/////////

// var mandatoryCollections = [];
// var excludeCollections = [];
// var excludedProducts = [];

// for (var c in storePickupSettings.mandatory_collections) {
//     // Some stores have extra functions inside an empty array, this will cause errors, to prevent it we check for undefined
//     if(storePickupSettings.mandatory_collections[c].title === undefined) continue;
//     mandatoryCollections.push(storePickupSettings.mandatory_collections[c].title.replace(/'/g, '&apos;'));
// }
// for (var c in storePickupSettings.exclude_collections) {
//     if(storePickupSettings.exclude_collections[c].title === undefined) continue;
//     excludeCollections.push(storePickupSettings.exclude_collections[c].title.replace(/'/g, '&apos;'));
// }
// if (typeof storePickupSettings.exclude_products !== "undefined" && storePickupSettings.exclude_products.length) {
//     for (var c in storePickupSettings.exclude_products) {
//         var prod = storePickupSettings.exclude_products[c];
//         excludedProducts.push(prod.id.replace('gid://shopify/ProductVariant/', ''));
//     }
// }

// var productCollections = document.querySelectorAll('.storepickup-product-collection'), i;
// var crCartProductIds = document.querySelectorAll('.cr-item-id');
// var pickupContainer = document.getElementById("pickup-container");
// //var storeForm = pickupContainer.closest("form");

// if (pickupProductInCart === true) {
//    // storeForm.querySelector('[name="checkout"]').style = 'display: none;' // hide the form till we load the pickup options
// }
// var excludedFromPickup = false;
// var mandatoryForPickup = false;
// for (i = 0; i < productCollections.length; ++i) {
//     var value = productCollections[i].innerHTML.replace(/'/g, '&apos;').replace(/&amp;/, '&');
//     // If there is an item in the cart exluded from pickup, we'll not display the store pickup option at all
//     if (excludeCollections.indexOf(value) > -1) {
//         //document.querySelector('#pickup-container').style = 'display: none;';

//         //document.querySelector('#pickup-container').remove();
//         //break;
//         excludedFromPickup = true;
//     }
//     if (mandatoryCollections.indexOf(value) > -1) {
//         mandatoryForPickup = true;
//         if (typeof document.querySelector('.pickup-button') !== 'undefined' && document.querySelector('.pickup-button')) {
//             document.querySelector('.pickup-button').style = 'display: none;';
//         }

//         if (typeof document.querySelector('.cr-delivery-button') !== 'undefined' && document.querySelector('.cr-delivery-button')) {
//             document.querySelector('.cr-delivery-button').style = 'display: none;';
//         }

//         var newItem = document.createElement("span");
//         newItem.style = 'font-weight: bold;';
//         var mandatoryForPickupText = ''//pickupTranslations.en.mandatoryForPickupText? pickupTranslations.en.mandatoryForPickupText : 'An item in your cart must be collected';
//         var textnode = document.createTextNode(mandatoryForPickupText);
//         newItem.appendChild(textnode);

//         pickupContainer.insertBefore(newItem, pickupContainer.childNodes[0]);
//         //storeForm.querySelector('[name="checkout"]').style = 'display: none;'
//         break;
//     }
// }

// for (i = 0; i < crCartProductIds.length; ++i) {
//     var prId = crCartProductIds[i].innerHTML;
//     if (excludedProducts.indexOf(prId) > -1) {
//         excludedFromPickup = true;
//         break;
//     }
// }

// document.addEventListener('crJQActivated', function (e) {
//     if (excludedFromPickup === true && mandatoryForPickup === false && typeof skipExcludedCheck === 'undefined') {
//         if (typeof crDeliverySettings !== "undefined" && crDeliverySettings.enabled === true) {
//             document.querySelector('.pickup-button').style = 'display: none;';
//             document.querySelector('.pickup-button').classList.remove("selected");
//         } else {
//             if (document.querySelector('#pickup-container')) {
//                 document.querySelector('#pickup-container').remove();
//             }
//         }

//         // Remove pickup and refresh the page if only the pickup item is in the cart
//         var productData = {quantity: 0,id: pickupProduct};

//         jqCR.getJSON('/cart', function(e){
//             var items = e.items;
//             for (var i in items) {
//                 if(String(items[i].id) === pickupProduct) {
//                     jqCR.post('/cart/change.js', productData, function() {
//                         console.log('refresh');
//                         if (pickupProduct) {
//                             location.reload();
//                         }

//                     }, 'json')
//                 }
//             }
//         })
//     }
// })


